import React, { PureComponent } from "react"
import "./AppImagePicker.css"
import "./AppImagePickerMobile.css"
import "./AppImagePickerTablet.css"
import { SelectionPreview } from "./ImagePicker/Components/SelectionPreview"
import { SelectionManager, SelectionAction, SelectionData } from "./ImagePicker/Stores/selection-manager"
import { locale } from "./locale"
import { SharedContext, SharedContextData } from "./contexts"
import { PhotoItem } from "./item"

type AppImagePickerProps = {
  language: string
  onSelectedItems: (items: PhotoItem[]) => {}
  range?: { max: number; min: number }
  showSelection?: boolean
  shouldSort?: boolean
  selectItemsText?: string
  completeOnSelect?: boolean
  optionalButtons?: []
}

type AppImagePickerState = {
  shared: SharedContextData
}

export class AppImagePicker extends PureComponent<AppImagePickerProps, AppImagePickerState> {
  static contextType = SharedContext

  constructor(props: AppImagePickerProps) {
    super(props)

    // node: workaround to define the required language globally to support legacy
    locale.language = props.language

    this.state = {
      shared: new SharedContextData({
        locale: locale.get(props.language),
        selection: new SelectionManager(),
        completeOnSelect: !!props.completeOnSelect
      })
    }
  }

  componentDidMount() {
    this.state.shared.selection.addListener(this.checkCompleteOnSelect)
  }

  //If completeOnSelection prop is true, then run doneSelecting as soon as an image has been selected
  checkCompleteOnSelect = (action: SelectionAction) => {
    if (this.props.completeOnSelect && this.state.shared.selection.getSelectedItems().length > 0) {
      this.doneSelecting()
    }
  }

  componentWillUnmount() {
    this.state.shared.dispose() // to release the depended resources
    this.state.shared.selection.removeListener(this.checkCompleteOnSelect)
  }

  doneSelecting = () => {
    const items = this.state.shared.selection.getSelectedItems()
    this.props.onSelectedItems(items)
  }

  render() {
    const { props, state } = this
    const { children, showSelection, shouldSort, range, selectItemsText, completeOnSelect, optionalButtons } = props
    return (
      <SharedContext.Provider value={state.shared}>
        <div className="photoselector-app">
          {typeof children == "function" ? children(state.shared) : children}
          {!completeOnSelect && (
            <SelectionPreview
              store={state.shared.selection}
              showSelection={showSelection}
              shouldSort={shouldSort}
              onSelect={this.doneSelecting}
              range={range}
              selectItemsText={selectItemsText}
              optionalButtons={optionalButtons}
            />
          )}
        </div>
      </SharedContext.Provider>
    )
  }
}
